require('./brokerInterestModal.scss');
const { FormattedText } = require('core/i18n').i18n;

const OKModal = require('components/commons/OKModal/OKModal');

class BrokerInterestModal extends React.Component {
  buildModalBody() {
    return (
      <section className="broker-interest-modal__content">
        <section className={'broker-interest-modal__first-pharagraph'}>
          <FormattedText value="brokerInternalTransferFund-modalFirstPharagraph" />
        </section>
        <section>
          <div className={'broker-interest-modal__example-pharagraph'}>
            <FormattedText value="brokerInternalTransferFund-modalExamplePharagraph" />
          </div>
          <ol>
            <li>
              <FormattedText value="brokerInternalTransferFund-modalExampleItemUno" />
            </li>
            <li>
              <FormattedText value="brokerInternalTransferFund-modalExampleItemDos" />
            </li>
          </ol>
        </section>
      </section>
    );
  }

  render() {
    const modalContent = this.buildModalBody();

    return (
      <OKModal
        content={modalContent}
        isOpen={this.props.isOpen}
        onCloseCallback={this.props.onCloseCallback}
        title="brokerInternalTransferFund-modalInterestTitle"
        titleAlignment="center"
        size="regular"
        footerType="action"
        primaryButtonText={'Continuar'}
        onPrimaryButtonClick={this.props.onCloseCallback}
      />
    );
  }
}

module.exports = BrokerInterestModal;
